import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  List,
  Spin,
  message,
  Modal,
  Divider,
  Input,
  Radio,
  Icon,
} from "antd";
import user from "../store/soap/user.js";

import IconText from "../components/common/List/IconText";

export default class ReasearchList extends Component {
  state = {
    users: [],
    modal: false,
    userUpdate: {
      matricula: "",
      role: "",
    },
    load: true,
  };

  async componentDidMount() {
    this.loadUsers();
  }

  async loadUsers() {
    let _users = [];
    try {
      _users = (await user.getUsers()).data;
      console.log(_users);
    } catch (e) {
      message.warning("Error, tente novamente.");
    }

    this.setState({
      users: _users,
      load: false,
    });
  }

  deleteUser = async (id) => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm("Você deseja excluir esse usuário?")) {
      try {
        await user.deleteUsers(id);
        message.warning("Usuário excluido com sucesso.");
        this.loadUsers();
      } catch (e) {
        message.warning("Error, tente novamente.");
      }
    }
  };
  modalUpdate = async (userUpdate) => {
    this.setState({
      userUpdate: userUpdate,
      modal: true,
    });
  };

  onChangeUserUpdate = (e, key) => {
    const _userUpdate = this.state.userUpdate;
    _userUpdate[key] = e.target.value;
    this.setState({ userUpdate: _userUpdate });
  };

  changeUser = async () => {
    try {
      message.loading("Salvando...");
      await user.updateUsers(this.state.userUpdate);
      message.success("Usuário atualizado com sucesso.");
      this.setState({
        modal: false,
      });
    } catch (error) {
      console.log(error);
      const { response } = error;
      if (response.data.message) {
        return message.warning(response.data.message);
      }
      message.warning("Error, tente novamente.");
    }
  };

  render() {
    const plainOptions = ["user", "admin"];
    return (
      <>
        <Modal
          title="Atualizar usuário"
          style={{ top: 20 }}
          visible={this.state.modal}
          onOk={this.changeUser}
          onCancel={() => this.setState({ modal: false })}
          okText="Salvar"
          cancelText="Fechar"
        >
          <Divider orientation="left">Matrícula DMA:</Divider>
          <Input
            placeholder="Matrícula"
            size="large"
            prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
            value={this.state.userUpdate.matricula}
            onChange={(e) => this.onChangeUserUpdate(e, "matricula")}
          />

          <Divider orientation="left">Permissão de acesso</Divider>
          <Radio.Group
            options={plainOptions}
            onChange={(e) => this.onChangeUserUpdate(e, "role")}
            value={this.state.userUpdate.role}
          />
        </Modal>

        {this.state.users.length === 0 && !this.state.load && (
          <h3 style={{ textAlign: "center", margin: "50px" }}>
            Não há usuários no momento.
          </h3>
        )}
        {this.state.users.length > 0 && !this.state.load && (
          <List
            itemLayout="vertical"
            size="large"
            dataSource={this.state.users}
            footer={
              <div>
                <b>Total</b> {this.state.users.length} usuário(s)
              </div>
            }
            renderItem={(item) => (
              <List.Item
                key={item.email}
                actions={[
                  <Button size="small" onClick={() => this.modalUpdate(item)}>
                    <IconText
                      type="share-alt"
                      text={`Permissão: ${item.role}`}
                    />
                  </Button>,
                  <Button
                    type="danger"
                    size="small"
                    onClick={() => this.deleteUser(item.id)}
                    key="delete"
                  >
                    Deletar usuário
                  </Button>,
                ]}
              >
                <List.Item.Meta
                  title={`Usuário: ${item.name}`}
                  description={`E-mail:  ${item.email}`}
                />
              </List.Item>
            )}
          />
        )}
        {this.state.load && <Spin className="spin-dma" />}
        <Link to="/user/new">
          <Button
            type="primary"
            shape="round"
            icon="user-add"
            size="large"
            className="float-action-button dma-primary"
          >
            Novo usuário
          </Button>
        </Link>
      </>
    );
  }
}
